<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import DataCenterCard from '@components/ui/cards/data-center-card.vue'
import PlainCard from '@components/ui/cards/plain-card.vue'
import Pagination from '@components/ui/basic-pagination.vue'
import queryString from 'query-string'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: [{ name: 'description', content: 'The Legal Analysis page.' }],
    }
  },
  components: {
    Layout,
    Hero,
    DataCenterCard,
    PlainCard,
    Pagination,
  },
  filters: {
    excerpt: function(text, limit) {
      return text
        .split(/\s+/)
        .slice(0, limit)
        .join(' ')
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    s3: function(path) {
      return appConfig.s3_endpoint + path
    },
  },
  data() {
    return {
      articles: {},
      categories: [],
      selectedCategory: '',
      activeID: '',
      page: window.location.search
        ? window.location.search.split('=').pop()
        : 1,
      limit: 10,
      totalPages: 1,
      totalData: 0,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** skeleton and loading state */
      loadOpacity: false,
      isLoading: true,
      firstLoad: false,
      /** for SEO, meta and hero */
      pageName: 'default',
      pageTitle: 'Loading...',
      pageDescription: '',
      notFound: false,
      categoryQuery: '',
    }
  },
  watch: {
    page: function() {
      this.loadOpacity = true
      if (this.page >= 1) {
        return new Promise((resolve, reject) => {
          resolve(this.getLegalAnalysis())
        })
      }
    },
  },
  async mounted() {
    if (queryString.parse(window.location.search).catID) {
      await this.getLegalAnalysis({
        taxonomy: {
          category: queryString.parse(window.location.search).catID,
        },
      })
      this.activeID = queryString.parse(window.location.search).catID
      this.selectedCategory = queryString.parse(window.location.search).cat
      this.categoryQuery = `${encodeURIComponent(
        this.activeID
      )}_${encodeURIComponent(this.selectedCategory)}`
    } else if (window.location.hash) {
      const params = window.location.hash.substring(1).split('_')
      this.selectedCategory = params[1]
      this.activeID = params[0]
      await this.getLegalAnalysis({
        taxonomy: {
          category: params[0],
        },
      })
    } else {
      await this.getLegalAnalysis()
    }

    await this.getCategories()
  },
  methods: {
    getLegalAnalysis: function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'legal-analysis',
        simple: true,
        page: this.page,
        limit: this.limit,
        order: 'DESC',
        order_by: 'created_at',
        lang: this.lang,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param, 'taxonomy', false)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      // console.log(endpoint)
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (response.data && data.length !== 0) {
          this.notFound = false
          this.articles = data
          this.isLoading = false
          this.loadOpacity = false
          this.totalPages = response.data.page_total
          this.totalData = response.data.data_total
          /** FOR SEO and META tag */
          let key
          if (response.data.info[this.lang]) {
            key = response.data.info[this.lang]
          } else {
            key = response.data.info[this.lang + ' ']
          }
          this.pageTitle = key[0].trim()
          this.pageDescription = key[1].trim()
        } else {
          this.notFound = true
        }
        this.firstLoad = true
      })
    },
    getCategories: function() {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'legal-analysis',
        simple: true,
        taksonomi_slug: this.lang === 'en' ? 'category-en' : 'category',
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params)
      /** define endpoint */
      var endpoint = `klaster-taksonomi?${params}`
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (data) {
          this.categories = data
        }
      })
    },
    slugify: function(title) {
      var slug = ''
      // Change to lower case
      var titleLower = title.toLowerCase()
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd')
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '')
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-')

      return slug
    },
    getArticleByCategory: function(catID, catName) {
      this.activeID = catID
      // console.log(catID)
      this.page = 0
      this.selectedCategory = catName
      history.pushState(
        {},
        null,
        this.$route.path +
          `#${encodeURIComponent(catID)}_${encodeURIComponent(catName)}`
      )
      this.categoryQuery = `${encodeURIComponent(catID)}_${encodeURIComponent(
        catName
      )}`
      this.getLegalAnalysis({
        taxonomy: {
          category: catID,
        },
      })
    },
    /**
     * Render category name
     */
    renderCategory: function(Obj, type = 'title') {
      if (this.lang === 'en') {
        if (Obj.length !== 0 && Obj.category_en && Obj.category_en.data[0]) {
          return Obj.category_en.data[0][type] + '/'
        } else {
          return ''
        }
      } else {
        if (Obj.length !== 0 && Obj.category.data[0]) {
          return Obj.category.data[0][type] + '/'
        } else {
          return ''
        }
      }
    },

    /**
     * Handler paginate
     */
    pageHandler: function(to) {
      this.page = to
      this.scrollToTargetAdjusted('legal-analysis-handler')
    },
  },
}
</script>

<template>
  <Layout>
    <Hero
      height="25rem"
      :background="require('@assets/images/demo/legal-analysis/Banner_0.jpg')"
    >
      <b-container class="h-100">
        <b-row class="justify-content-center h-100">
          <div class="col-lg-12 text-center align-self-center">
            <h1
              class="text-white"
              :style="{ fontSize: '2.75rem', fontWeight: '700' }"
              >{{ pageTitle }}</h1
            >
            <p
              class="mt-3 mb-4"
              :style="{
                color: '#fff',
                fontSize: '1.2rem',
                fontWeight: '300',
              }"
              >{{ pageDescription }}</p
            >
          </div>
        </b-row>
      </b-container>
    </Hero>

    <b-container id="legal-analysis-handler" class="my-5 position-relative">
      <img
        v-show="isLoading && firstLoad === false"
        src="@assets/icons/loading.gif"
        alt="loading"
        class="loadingIcon"
      />
      <b-row v-if="!isLoading">
        <b-col cols="lg-8" class="mt-0 mt-lg-3">
          <div>
            <h1>
              {{
                selectedCategory !== ''
                  ? decodeURI(selectedCategory)
                  : $t('All Categories')
              }}
            </h1>
          </div>
          <div v-if="!notFound">
            <div
              v-for="(article, index) in articles"
              :key="index"
              class="eachCard"
            >
              <!-- eslint-disable -->
              <DataCenterCard
                v-if="article.taksonomi"
                :title="article.title"
                heading-tag="a"
                :category="renderCategory(article.taksonomi).slice(0, -1)"
                :class="[loadOpacity ? 'isLoading' : '']"
                :url="
                  '/legal-analysis/' +
                    article.slug +
                    '/' +
                    renderCategory(article.taksonomi) +
                    renderCategory(article.taksonomi, 'ktaksonomi_record_id') +
                    `?page=${page}${
                      categoryQuery ? '&cat=' + categoryQuery : ''
                    }`
                "
              >
                <!-- eslint-enable -->
                <div
                  v-if="
                    article.atribut.caption &&
                      article.atribut.caption.data.length !== 0
                  "
                >
                  <div
                    v-for="(caption, i) in article.atribut.caption.data"
                    :key="i"
                  >
                    <span v-if="caption.content">{{ caption.content }}</span>
                    <span v-else>
                      {{ article.content | plainText | excerpt(40) }}...
                    </span>
                  </div>
                </div>
                <div v-else>
                  {{ article.content | plainText | excerpt(40) }}...
                </div>
              </DataCenterCard>
            </div>
            <Pagination
              v-if="totalData > 10"
              :total-pages="totalPages"
              :selected-page="Number(page)"
              :limit="limit"
              class="my-5"
              @clicked="pageHandler"
            ></Pagination>
          </div>
          <div v-if="notFound">
            <span> {{ $t('No data') }} </span>
          </div>
        </b-col>
        <b-col cols="lg-4" class="mt-3 mt-lg-5">
          <PlainCard
            :title="$t('Categories')"
            :header-border="false"
            background="#F7F7F7"
            class="px-2 py-3 mt-lg-5 mt-0"
            :class="$style.categories"
          >
            <ul :class="$style.categoryList">
              <li v-for="(category, index) in categories" :key="index">
                <router-link
                  :to="`/legal-analysis?catID=${category.ID}`"
                  event
                  style="display:contents;text-decoration:none"
                  @click.native="
                    getArticleByCategory(category.ID, category.title)
                  "
                >
                  <img
                    v-for="(icon, i) in category.atribut"
                    :key="i"
                    :src="icon.data[0].content | s3"
                    alt=""
                  />
                  <span
                    :class="activeID === category.ID ? $style.active : ''"
                    >{{ category.title }}</span
                  >
                </router-link>
              </li>
            </ul>
          </PlainCard>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.categories {
  // position: sticky;
  // top: 6rem;
  .categoryList {
    padding-left: 0.5rem;
    li {
      display: flex;
      margin: 1rem 0;
      list-style: none;
      cursor: pointer;
      img {
        width: 30px;
        object-fit: contain;
        margin-right: 1rem;
      }
      span {
        &.active {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
